import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { RealPainSection } from './components/RealPainSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { WhyFailSection } from './components/WhyFailSection';
import { ProtocolSection } from './components/ProtocolSection';
import { AboutKate } from './components/AboutKate';
import { ServicesMenu } from './components/ServicesMenu';
import { FeaturedTreatments } from './components/FeaturedTreatments';
import { GuaranteeSection } from './components/GuaranteeSection';
import { HoursLocation } from './components/HoursLocation';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { WhatsAppFloat } from './components/WhatsAppFloat';
import { PromoBanner } from './components/PromoBanner';
import { LanguageProvider } from './context/LanguageContext';
import { SEOHead } from './components/SEOHead';
import { IntroCurtain } from './components/IntroCurtain';
import { GiftCardSection } from './components/GiftCardSection';
export function App() {
  return <LanguageProvider data-id="element-0" data-mp="3recd7hndojem">
      <SEOHead data-id="element-1" data-mp="5ygolyg4xb6" />
      <IntroCurtain data-id="element-2" data-mp="6hpnd64cbd2" />
      <div className="min-h-screen bg-brand-white font-sans text-brand-charcoal selection:bg-brand-gold/30" data-id="element-3" data-mp="4n4bxqxqh8g">
        <PromoBanner data-id="element-4" data-mp="2zmo557bmuj1l" />
        <Header data-id="element-5" data-mp="2zn6bwxvx8fnr" />
        <main data-id="element-6" data-mp="33mow1rfx4mpj">
          <HeroSection data-id="element-7" data-mp="33m5b01uz1i7a" />
          <ServicesMenu data-id="element-8" data-mp="33nq55qddiz4m" />
          <FeaturedTreatments data-id="element-9" data-mp="33mykhalbelt4" />
          <PainSection data-id="element-10" data-mp="38lrpsfqg76i7" />
          <RealPainSection data-id="element-11" data-mp="38li8dgjgy7o4" />
          <ProtocolSection data-id="element-12" data-mp="38k6uup081ljt" />
          <TestimonialsSection data-id="element-13" data-mp="38o4gpie6or7e" />
          <WhyFailSection data-id="element-14" data-mp="3dle3sre3oqs2" />
          <AboutKate data-id="element-15" data-mp="3dlnsmbnesrw6" />
          <GuaranteeSection data-id="element-16" data-mp="3dirv2ofh4589" />
          <HoursLocation data-id="element-17" data-mp="nvsvh92bsvy2" />
          <FAQSection data-id="element-18" data-mp="nwc582htoe10" />
          <GiftCardSection data-id="element-19" data-mp="nv0xjrl9am4m" />
          <FinalCTA data-id="element-20" data-mp="nxwvvh10nctl" />
        </main>
        <Footer data-id="element-21" data-mp="stuejtzr4v9j" />
        <WhatsAppFloat data-id="element-22" data-mp="stc8y6r794oy" />
      </div>
    </LanguageProvider>;
}